import { render, staticRenderFns } from "./learnCurve.vue?vue&type=template&id=b088d0c2&scoped=true&"
import script from "./learnCurve.vue?vue&type=script&lang=js&"
export * from "./learnCurve.vue?vue&type=script&lang=js&"
import style0 from "./learnCurve.vue?vue&type=style&index=0&id=b088d0c2&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b088d0c2",
  null
  
)

export default component.exports